// export const DEFAULT_BROWSER_URL = "http://localhost:3000";
// export const DEFAULT_BACKEND_URL = "http://localhost:4000";
export const DEFAULT_BROWSER_URL = "https://spiderx.io/";
export const DEFAULT_BACKEND_URL = "https://api-v1.spiderx.io:4000";
export const DEFAULT_TTL = 86400000; // one day
